/* Prevent Gatsby from crashing on build */
/* https://github.com/purposeindustries/window-or-global */

/* eslint-disable no-restricted-globals */

"use strict"
module.exports =
  (typeof self === "object" && self.self === self && self) ||
  (typeof global === "object" && global.global === global && global) ||
  this
